const IconArrowDown = `<svg viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M1.40614 0.000396729L6 4.93715L10.5934 0.000396729L12 1.51929L6 8.0004L0 1.51929L1.40614 0.000396729Z" fill="white"/>
</svg>
`;

export { IconArrowDown as I };
